import './chart_view.js.coffee';# Added by Script 
Monitoring.Views.Charts ||= {}

class Monitoring.Views.Charts.NoteChartView extends Monitoring.Views.Charts.ChartView
  template: JST['backbone/templates/monitoring/charts/note_chart']

  events:
    'keyup': 'countChars'

  initialize: (name) ->
    @name = name
    @character_limit = 500

  render: (text_note) =>
    @$el.html(@template({name: @name}))
    @$el.find('#chart_note_' + @name).val(text_note)
    @countChars()
    @

  countChars: ->
    txtObj = @$el.find('#chart_note_' + @name)
    txtCounter = @$el.find('#counter_chart_note_' + @name)
    btnSave = @$el.find('#save_note')
    if txtObj
      txtCounter.text(txtObj.val().length + '/' + @character_limit)
      if (txtObj.val().length > @character_limit)
        btnSave.prop('disabled', true);
        btnSave.addClass('disabled')
        txtCounter.addClass('counter_exceeded')
      else
        btnSave.prop('disabled', false);
        btnSave.removeClass('disabled')
        txtCounter.removeClass('counter_exceeded')

  getValue: ->
    @$el.find('#chart_note_' + @name).val()

  clearValue: ->
    @$el.find('#chart_note_' + @name).val('')
